import { all } from "redux-saga/effects";

import authAdminSaga from "./authAdminSaga";
import authTenantSaga from "./authTenantSaga";
import adjustmentOrderSaga from "./adjustmentOrderSaga";
import categorySaga from "./categorySaga";
import customerSaga from "./customerSaga";
import dashboardSaga from "./dashboardSaga";
import inventorySaga from "./inventorySaga";
import planSaga from "./planSaga";
import productSaga from "./productSaga";
import purchaseSaga from "./purchaseSaga";
import salesSaga from "./salesSaga";
import supplierSaga from "./supplierSaga";
import supportRequestSaga from "./supportRequestSaga";
import tenantSaga from "./tenantSaga";
import tenantUserSaga from "./tenantUserSaga";
import transactionSaga from "./transactionSaga";

export default function* rootSaga() {
  yield all([
    authAdminSaga(),
    authTenantSaga(),
    adjustmentOrderSaga(),
    categorySaga(),
    customerSaga(),
    dashboardSaga(),
    inventorySaga(),
    planSaga(),
    productSaga(),
    purchaseSaga(),
    salesSaga(),
    supplierSaga(),
    supportRequestSaga(),
    tenantSaga(),
    tenantUserSaga(),
    transactionSaga(),
  ]);
}
